/* eslint-disable import/no-cycle */
import { Divider } from '@chakra-ui/core';
import React from 'react';
import { ScreeningType } from '../formElements/ScreeningType';
import { QuestionRequireResponse } from '../formElements/QuestionRequireResponse';
import { MaxAnswerLengthInput } from './MaxAnswerLengthSelect';
import { SCREENING_TYPE } from '../../../questionnaireTemplate.enums';
import { QuestionnaireBuilderElementProps } from '../../../questionnaireTemplate.types';

export const FreeForm = React.memo(function FreeForm({ elementId }: QuestionnaireBuilderElementProps) {
  return (
    <>
      <MaxAnswerLengthInput id={elementId} />
      <Divider borderColor="rgba(204, 230, 255, 1)" />
      <ScreeningType id={elementId} screeningTypes={[SCREENING_TYPE.NONE, SCREENING_TYPE.REVIEW]} />
      <QuestionRequireResponse elementId={elementId} />
    </>
  );
});
